import { Check, StickyNote } from 'lucide-react'
import { useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { memoPath } from '@/routes/paths'

/** カードを作ったあとの知らせ（開いて書き足せる） */
export const CardCreatedNotice = ({ memoId, className }: { memoId: number; className?: string }) => {
  const navigate = useNavigate()
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 rounded-lg border border-primary/40 p-2.5 text-sm',
        className,
      )}
    >
      <span className="flex items-center gap-1.5 text-primary">
        <Check className="size-4" />
        カードにしました
      </span>
      <Button size="sm" variant="ghost" className="px-2!" onClick={() => navigate(memoPath(memoId))}>
        <StickyNote className="size-4" />
        開く
      </Button>
    </div>
  )
}
